/* KonpreShop — Shopify theme interactions */
(function () {
  "use strict";

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setNav(open) {
    document.body.classList.toggle("nav-open", open);
    var t = document.querySelector(".nav-toggle");
    if (t) t.setAttribute("aria-expanded", open ? "true" : "false");
  }
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-nav-open]"))       { e.preventDefault(); setNav(true);  }
    else if (e.target.closest("[data-nav-close]")) { e.preventDefault(); setNav(false); }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") setNav(false);
    if (e.key === "/" && !e.defaultPrevented) {
      var tag = (e.target.tagName || "").toLowerCase();
      if (tag === "input" || tag === "textarea" || tag === "select" || e.target.isContentEditable) return;
      var input = document.querySelector(".search-pill--header .search-pill__input");
      if (input) { e.preventDefault(); input.focus(); }
    }
  });

  function swapImg(img, src) {
    if (!img || !src) return;
    img.classList.add("img-loading");
    img.src = src;
    img.onload = function () { img.classList.remove("img-loading"); };
    img.onerror = function () { img.classList.remove("img-loading"); };
  }

  document.addEventListener("click", function (e) {
    var thumb = e.target.closest(".gallery__thumb");
    if (!thumb || thumb.closest(".pdp")) return;
    e.preventDefault();
    var main = document.getElementById("mainImage");
    var full = thumb.getAttribute("data-full");
    if (main && full) swapImg(main, full);
    document.querySelectorAll(".gallery__thumb").forEach(function (t) { t.setAttribute("aria-pressed", "false"); });
    thumb.setAttribute("aria-pressed", "true");
  });

  document.querySelectorAll(".hero-slider").forEach(function (root) {
    var track  = root.querySelector(".hs-track");
    var slides = [].slice.call(root.querySelectorAll(".hs-slide"));
    if (!track || slides.length < 2) return;
    var i = 0, timer = null;
    var delay = parseInt(root.getAttribute("data-autoplay") || "5000", 10);
    var dotsWrap = root.querySelector(".hs-dots");
    if (dotsWrap) dotsWrap.innerHTML = slides.map(function (_, n) {
      return '<button class="hs-dot" aria-label="Banner ' + (n + 1) + '"></button>';
    }).join("");
    var dots = dotsWrap ? [].slice.call(dotsWrap.children) : [];
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = "translateX(" + (-i * 100) + "%)";
      dots.forEach(function (d, k) { d.setAttribute("aria-current", k === i ? "true" : "false"); });
    }
    function start() { stop(); timer = setInterval(function () { go(i + 1); }, delay); }
    function stop()  { if (timer) clearInterval(timer); }
    var nx = root.querySelector(".hs-next"), pv = root.querySelector(".hs-prev");
    if (nx) nx.addEventListener("click", function () { go(i + 1); start(); });
    if (pv) pv.addEventListener("click", function () { go(i - 1); start(); });
    dots.forEach(function (d, k) { d.addEventListener("click", function () { go(k); start(); }); });
    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", function () { if (!reducedMotion) start(); });
    go(0);
    if (!reducedMotion) start();
  });

  document.querySelectorAll("[data-card]").forEach(function (card) {
    var dotsWrap = card.querySelector(".variant-dots");
    if (!dotsWrap) return;
    var art   = card.querySelector("[data-card-art]");
    var label = card.querySelector("[data-card-label]");
    var hint  = card.querySelector("[data-variant-hint]");
    var img   = card.querySelector("[data-card-img]");
    var media = card.querySelector("[data-card-media]");
    var price = card.querySelector(".price");
    var promo = card.querySelector(".promo-sticker--percent");
    var newBadge = card.querySelector(".badge--new");
    var activeLabel = "";
    var firstDot = dotsWrap.querySelector(".vdot[aria-pressed='true']");
    if (firstDot) activeLabel = firstDot.getAttribute("data-label") || "";

    var raw = dotsWrap.getAttribute("data-variants");
    if (raw) {
      try {
        var variants = JSON.parse(raw);
        var shown = variants.slice(0, 4), extra = variants.length - 4;
        shown.forEach(function (v, i) {
          var btn = document.createElement("button");
          btn.className = "vdot"; btn.type = "button";
          btn.setAttribute("aria-pressed", i === 0 ? "true" : "false");
          btn.setAttribute("aria-label", v.label);
          btn.setAttribute("data-idx", i);
          btn.setAttribute("data-label", v.label);
          btn.style.background = v.color;
          var hx = v.color.replace("#",""); if(hx.length===3) hx=hx[0]+hx[0]+hx[1]+hx[1]+hx[2]+hx[2];
          var rr=parseInt(hx.slice(0,2),16)/255,gg=parseInt(hx.slice(2,4),16)/255,bb=parseInt(hx.slice(4,6),16)/255;
          if (0.299*rr+0.587*gg+0.114*bb > 0.70) btn.classList.add("vdot--light");
          dotsWrap.appendChild(btn);
        });
        if (extra > 0) { var chip=document.createElement("span"); chip.className="vdot-more"; chip.textContent="+"+extra+" más"; dotsWrap.appendChild(chip); }
      } catch(e) {}
    }

    dotsWrap.querySelectorAll(".vdot").forEach(function (btn) {
      var vLabel = btn.getAttribute("data-label") || "";
      var vImg   = btn.getAttribute("data-img")   || "";
      btn.addEventListener("mouseenter", function () {
        if (label) label.textContent = vLabel;
        if (hint)  { hint.textContent = vLabel; hint.setAttribute("data-active",""); }
        if (img && vImg) swapImg(img, vImg);
      });
      btn.addEventListener("mouseleave", function () {
        if (label) label.textContent = activeLabel;
        if (hint)  hint.removeAttribute("data-active");
        var aD = dotsWrap.querySelector(".vdot[aria-pressed='true']");
        if (img && aD && aD.getAttribute("data-img")) swapImg(img, aD.getAttribute("data-img"));
      });
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        dotsWrap.querySelectorAll(".vdot").forEach(function(d){ d.setAttribute("aria-pressed","false"); });
        btn.setAttribute("aria-pressed","true"); activeLabel = vLabel;
        if (label) label.textContent = vLabel;
        if (img && vImg) swapImg(img, vImg);
        if (hint) {
          hint.textContent = vImg ? vLabel : vLabel + " · foto no disponible";
          hint.setAttribute("data-active","");
        }
        if (media && btn.dataset.variantUrl) media.href = btn.dataset.variantUrl;
        if (price && btn.dataset.price) {
          price.textContent = btn.dataset.price;
          price.classList.toggle("price--sale",!!btn.dataset.compare);
          if (btn.dataset.compare) {
            var oldPrice=document.createElement("span");
            oldPrice.className="was";
            oldPrice.textContent=btn.dataset.compare;
            price.appendChild(oldPrice);
          }
        }
        if (promo) {
          promo.style.display=btn.dataset.discount?"":"none";
          promo.setAttribute("aria-label",btn.dataset.discount?btn.dataset.discount+"% de descuento en esta variante":"");
          var promoText=promo.querySelector(".promo-sticker__label");
          if(promoText) promoText.textContent=btn.dataset.discount?"-"+btn.dataset.discount+"%":"";
        }
        if(newBadge) newBadge.style.display=btn.dataset.discount?"none":"";
      });
    });
  });

  (function(){
    var grid = document.getElementById("productGrid");
    if (!grid) return;
    var saved = localStorage.getItem("kp_view");
    function setView(v) {
      grid.classList.toggle("product-grid--list", v==="list");
      document.querySelectorAll(".vt-btn").forEach(function(b){ b.setAttribute("aria-pressed", b.getAttribute("data-view")===v?"true":"false"); });
      localStorage.setItem("kp_view", v);
    }
    document.querySelectorAll(".vt-btn").forEach(function(b){ b.addEventListener("click", function(){ setView(b.getAttribute("data-view")); }); });
    if (saved==="list") setView("list");
  })();

  /* ── Scroll reveal ──────────────────────────────────────────
     Tags below-fold section blocks (or their product/tile grids)
     and reveals them once on enter. Fully progressive: if JS does
     not run, nothing is ever hidden (we add the attributes here).
     Disabled entirely under reduced-motion or without IO support. */
  (function () {
    if (reducedMotion || !("IntersectionObserver" in window)) return;
    var main = document.getElementById("main");
    if (!main) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });

    var GRID = ".product-grid, .cat-grid, .brand-row, .value-grid, .spot-row, .stat-grid, .promo-grid";
    var pending = [], ticking = false;
    var blocks = [].slice.call(main.children).filter(function (el) {
      return el.nodeType === 1 && el.offsetHeight > 0;
    });

    blocks.forEach(function (el, idx) {
      if (idx === 0) return; /* hero / above the fold stays instant */
      var grid = el.querySelector(GRID);
      var target = el;
      if (grid) { grid.setAttribute("data-reveal-stagger", ""); target = grid; }
      else { el.setAttribute("data-reveal", ""); }

      var r = target.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92) { target.classList.add("is-in"); return; }
      io.observe(target);
      pending.push(target);
    });

    /* fix móvil 2026-10-14: respaldo del reveal. Si un scroll rápido o un salto
       deja atrás un bloque sin que el observer dispare, se muestra igual:
       ningún bloque que ya llegó al viewport queda con opacidad 0. */
    function sweep() {
      ticking = false;
      var limit = window.innerHeight * 0.92;
      pending = pending.filter(function (t) {
        if (t.classList.contains("is-in")) return false;
        if (t.getBoundingClientRect().top < limit) { t.classList.add("is-in"); io.unobserve(t); return false; }
        return true;
      });
      if (!pending.length) window.removeEventListener("scroll", onScroll);
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(sweep); } }
    if (pending.length) window.addEventListener("scroll", onScroll, { passive: true });
  })();

})();
